module.exports = __webpack_public_path__ + "img/app.1bb77388.png";